import { FunctionComponent } from "react";
import EventSwitcherCardPlaceholder from "../components/EventSwitcherCard/view/EventSwitcherCardPlaceholder.web";
import type { ScoreboardSlot } from "../scoreboard-slots.web";
import styles from "./EventViewHeader.web.module.css";

/**
 * The truly cold header — no warm at all. Reserves the slot's scoreboard alongside the switcher's
 * inside `<EventViewHeader>`'s own outer surfaces, or an unwarmed entry grows by the scoreboard's
 * height when the response lands. No slot, no scoreboard surface.
 */
const EventViewHeaderPlaceholder: FunctionComponent<{ slot?: ScoreboardSlot }> = ({ slot }) => (
  <>
    <EventSwitcherCardPlaceholder />
    {slot && <div className={styles.scoreboard}>{slot.renderPlaceholder()}</div>}
  </>
);

export default EventViewHeaderPlaceholder;
